import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link';

class Brand extends Component {
    render() {
        return(
            <section id="home" style={{opacity: 0.65}}>
                <div className="container h-100">
                    <div className="row align-items-center h-100">
                        <div id="homescreen" className="col-xs-12 col-lg-12 mx-auto">
                            <div id="logo">
                                <Link to="/"><img src="img/grubrun-logo-ml.png" width="500" alt="Grub Run logo art" /></Link>
                            </div>
                            <a href="https://www.apple.com/itunes/" target="_blank" className="downloadbutton" rel="noopener noreferrer">iOS</a>
                            <a href="https://play.google.com/store?hl=en" target="_blank" className="downloadbutton" rel="noopener noreferrer">Android</a>
                            <div id="slogan">
                                <h1>Tap. Go. Enjoy.</h1>
                            </div>
                            <div className="smooth-scroll" aria-hidden="true">
                                <Link smooth className="scroll-down hidden-xs" to="#features">
                                    <i className="fa fa-angle-down infinite animated fadeInDown"></i>
                                    <span className="sr-only">Jump to features</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Brand;